
const digest = 'f471287c1bdeccf080b87b49885bdeed40160f68b981b9b6ea1660b2b9edb5f5';
const classes = {"wrapper":"_wrapper_14za5_1","name":"_name_14za5_7","checkboxWrapper":"_checkboxWrapper_14za5_16","submitButton":"_submitButton_14za5_21"};
const css = `._wrapper_14za5_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_14za5_1 ._name_14za5_7 {
  font-weight: 600;
}
._wrapper_14za5_1 ._name_14za5_7 span {
  font-weight: 400;
}
._wrapper_14za5_1 tr td {
  padding: 5px 0;
}
._wrapper_14za5_1 ._checkboxWrapper_14za5_16 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
._wrapper_14za5_1 ._submitButton_14za5_21 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  